import * as React from 'react';
import ProjectData from 'src/value-objects/ProjectData';
import { baseApiRoute } from 'src/resources/const';
import RichEditContainer from 'src/modules/commons/inputs/rich-edit/RichEdit.container';

export interface ProjectMetricsFormComponentProps {
  formData: ProjectData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  handleRichEditor: (key: string) => (html: string) => void;
}

class ProjectMetricsFormComponent extends React.Component<ProjectMetricsFormComponentProps> {

  public render(): React.ReactNode {
    return (
      <div>
        <div className="f-s-26">
          Métricas
        </div>
        <div className="gap-20"/>
        <div className="row">
          <div className="col-md-12">
            <RichEditContainer
              onChange={(value) => this.props.handleRichEditor('metrics')(value)}
              placeholder="Añade las métricas"
              uploadURL={baseApiRoute + '/save-image'}
              value={this.props.formData.metrics}
            />
          </div>
        </div>
        <div className="gap-20"/>
      </div>
    );
  }
}

export default ProjectMetricsFormComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectMetricsForm.component.tsx